export default __webpack_public_path__ + "static/media/RaindropSensing@2x.87a9beeb.png";